import { Select } from "@mantine/core";
import * as App from "./../../model/App";

interface IPatentTypeSelectProps {
    value?: App.Data.App.PatentType;
    label?: string;
    placeholder?: string;
    disabled?: boolean;
    required?: boolean;
    onChange: (value: App.Data.App.PatentType) => void;
}

export default function PatentTypeSelect(props: IPatentTypeSelectProps) {
    const data = [
        { value: App.Data.App.PatentType.Patent.toString(), label: "Patent"},
        { value: App.Data.App.PatentType.UtilityModel.toString(), label: "Utility Model" },
        { value: App.Data.App.PatentType.IndustrialDesign.toString(), label: "Industrial Design" }
    ];

    return (
        <Select
            label={props.label ?? "Patent type"}
            placeholder={props.placeholder ?? "Patent type"}
            searchable
            disabled={props.disabled}
            required={props.required}
            value={props.value?.toString() ?? ""}
            data={data}
            onChange={(value: string | null) => { return props.onChange(value as any); } }
        />
    );
}
